<div [ngClass]="{ 'container-fluid': noRedirection, 'bg-white': noRedirection, 'tab-content-border': noRedirection }">
  <div class="container pt-4 pb-5" [ngClass]="{ 'container-shadow': !noRedirection, 'my-4': !noRedirection, 'mb-4': noRedirection }">
    <div class="text-center py-3" *ngIf="loading">
      <i class="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
    <div *ngIf="!loading">
      <div id="new_file_share">
        <h3 class="border-bottom pb-2">New File Share</h3>
        <div class="py-1"></div>
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">File Share Form</div>
              <div class="card-body">
                <h4>Recipients</h4>
                <p class="hint">Note: Only users involved with this matter that can be communicated with via email can recieve file shares.</p>
                <div id="contacts_list">
                  <div class="row" *ngFor="let contact of contacts">
                    <div class="col">
                      <app-form-checkbox [label]="contact.name + '(' + contact.email + ')'" [includeFormGroup]="true" (change)="changeContactSelection(contact)"></app-form-checkbox>
                    </div>
                  </div>
                </div>
                <form method="post">
                  <app-form-text-area label="Message to Recipients" [rows]="3" [(model)]="message"></app-form-text-area>
                  <h4>Files to be Shared</h4>
                  <p class="hint">Select documents and/or media to share from the list on the right.</p>
                  <div *ngIf="selectedFiles">
                    <table class="table table-sm">
                      <tbody>
                        <tr *ngFor="let file of selectedFiles">
                          <td>
                            <a type="button" class="add-document" (click)="removeFile(selectedFiles.indexOf(file))"><i class="fas fa-minus-circle"></i></a>&nbsp;{{ file.name }}
                          </td>
                          <td class="text-right">
                            <span *ngIf="file.media_type" class="text-info" title="Media">
                              <i class="fas fa-film"></i>
                            </span>
                            <span *ngIf="!file.media_type" title="Document">
                              <i class="fas fa-file-alt"></i>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="py-2"></div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="submit" class="btn btn-primary btn-block" (click)="makeFileShare()" [disabled]="formSubmitting">
                        {{ formSubmitting ? 'Creating' : 'Create' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span></button
                      >
                    </div>
                    <div class="col-md-6">
                      <button type="submit" class="btn btn-outline-secondary btn-block" (click)="cancelFileShare()" *ngIf="!noRedirection">Cancel</button>
                      <button type="submit" class="btn btn-outline-secondary btn-block" (click)="reset()" *ngIf="noRedirection">Reset</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <br />
          <div class="col-md-6">
            <h4>Select files to share</h4>
            <tabset>
              <tab heading="Document">
                <div class="py-2"></div>
                <h4>Filter Documents</h4>
                <form #docFilterForm="ngForm">
                  <app-form-checkbox label="Select All Documents" [includeFormGroup]="true" [(model)]="selectAllDocs"></app-form-checkbox>
                  <div class="row">
                    <div class="col-md-6">
                      <app-form-date-picker label="From" placeholder="Click to select date" [(model)]="filterValues.docFromDate"></app-form-date-picker>
                    </div>
                    <div class="col-md-6">
                      <app-form-date-picker label="To" placeholder="Click to select date" [(model)]="filterValues.docToDate"></app-form-date-picker>
                    </div>
                  </div>
                  <app-form-select label="Author" [selectOptions]="authors" [(model)]="filterValues.docAuthor"></app-form-select>
                  <div class="form-group">
                    <label class="form-control-label">Type</label>
                    <app-document-type-tree-select
                      [placeholder]="'Filter document types'"
                      [maxHeight]="300"
                      [documentTypeId]="filterValues.docType"
                      (document_type_id)="filterValues.docType = $event"
                      (clearDocumentType)="clearDocumentTypeFilter()"></app-document-type-tree-select>
                  </div>
                  <app-form-text-input label="Tags" [(model)]="filterValues.tags"></app-form-text-input>
                  <button type="button" class="btn btn-primary" (click)="filterDocs(docFilterForm)" [disabled]="filteringDocs">
                    {{ filteringDocs ? 'Filtering' : 'Filter' }}<span *ngIf="filteringDocs">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
                  </button>
                </form>
                <div class="py-2"></div>
                <div>
                  <div class="row py-2 border-top" *ngFor="let doc of documents">
                    <div class="col-6">
                      <a type="button" class="add-document" (click)="selectFile(doc)"><i class="fas fa-plus-circle"></i></a>&nbsp;<a [href]="'/documents/' + doc.id + '/download'" [title]="(doc.document_type_name || '') + (doc.document_type_name && doc.notes ? ' — ' : '') + (doc.notes || '')">{{ doc.shortName }}</a>
                    </div>
                    <div class="col-3">{{ doc.document_type_name }}</div>
                    <div class="col-3">
                      <span class="float-right">{{ dateFormatter(doc.authored_at) }}</span>
                    </div>
                  </div>
                  <div class="py-2"></div>
                  <div class="row py-2 border-top">
                    <app-pagination [page]="paginateParams.page" [perPage]="paginateParams.per_page" [totalCount]="docCount" (pageChanged)="loadDocs($event)"></app-pagination>
                  </div>
                </div>
              </tab>
              <tab heading="Media">
                <div class="py-2"></div>
                <div>
                  <div class="row py-2 border-top">
                    <div class="col-6 font-weight-bold">Name</div>
                    <div class="col-3 font-weight-bold">Type</div>
                    <div class="col-3 font-weight-bold">Created at</div>
                  </div>
                  <div class="row py-2 border-top" *ngFor="let medium of media">
                    <div class="col-6">
                      <a type="button" class="add-document" (click)="selectFile(medium)"><i class="fas fa-plus-circle"></i></a>&nbsp;{{ medium.name }}
                    </div>
                    <div class="col-3">{{ medium.media_type }}</div>
                    <div class="col-3">{{ dateFormatter(medium.created_at) }}</div>
                  </div>
                  <div class="row py-2 border-top">
                    <app-pagination [page]="paginateParams.page" [perPage]="paginateParams.per_page" [totalCount]="mediaCount" (pageChanged)="loadMediaFiles($event)"></app-pagination>
                  </div>
                </div>
              </tab>
            </tabset>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
